export const dropZoneTranslations = {
  validation: {
    fileExists: 'shared.dropZone.validation.file_exists',
    fileFormat: 'shared.dropZone.validation.file_format',
    fileSize: 'shared.dropZone.validation.file_size',
  },
  modal: {
    title: 'shared.dropZone.modal.title',
    subtitle: 'shared.dropZone.modal.subtitle',
  },
  delete: 'shared.dropZone.delete',
  error: 'shared.dropZone.error',
  format: 'shared.dropZone.format',
  formatOr: 'shared.dropZone.format_or',
  valid: 'shared.dropZone.valid',
  select: 'shared.dropZone.select',
  change: 'shared.dropZone.change',
  drag: 'shared.dropZone.drag',
  dragNew: 'shared.dropZone.drag_new',
}
